import { takeLatest, call, put } from 'redux-saga/effects';
import { DELETE_ABOUT_US_START, DELETE_ABOUT_US_ERROR, DELETE_ABOUT_US_SUCCESS, GET_ABOUT_US_START } from '../../types';

import apiCall from '../../../api/apiGet';

export function* del({ payload }) {
  try {
    const url = `/about-us/delete/${payload.id}`;
    const method = 'DELETE';
    const headers = {Authorization: `Bearer ${payload.token}`};
    const results = yield call(apiCall, url, method, headers);
    console.log(results)
    yield put({ type: DELETE_ABOUT_US_SUCCESS, results: results.data });
  } catch (error) {
    console.log(error)
    yield put({ type: DELETE_ABOUT_US_ERROR, error });
  } finally {
    yield put({ type: GET_ABOUT_US_START, payload: {lang: null, token: payload.token} });
    payload.navigate(-1)
  }
}

export default function* delete_about_us() {
  yield takeLatest(DELETE_ABOUT_US_START, del);
}
